// @ts-nocheck
import * as _17 from "../confio/proofs";
export const ics23 = {
  ..._17
};